// Who gets live work on Pulse, and which waiting conversations are theirs to
// take (ENG-3221 decision 14, riders 2 and 5). The bot uses these rules for
// what the AI is told, the server for the page's live read, so the two agree.
import { PulseEscalationEligibility, PulseLocationReach } from "./Pulse.Facts";
import { PulsePersona } from "./Pulse.Personas";

/** Personas who direct from Pulse and never take conversations from it: the Executive, and wave 2's three (ENG-3225, Mason 6 October). */
export const PULSE_NO_LIVE_WORK_PERSONAS: readonly PulsePersona[] = [
  PulsePersona.EXECUTIVE,
  PulsePersona.REGIONAL_MANAGER,
  PulsePersona.HEAD_OF_OPERATIONS,
  PulsePersona.MARKETING_REPUTATION
];

/**
 * Live work applies to members who can take escalations, and to Team Leads,
 * who direct the floor. Never to the personas who direct from Pulse without
 * working conversations. Null eligibility (it couldn't be read) gives no live work.
 */
export function pulseLiveWorkApplies(persona: PulsePersona, canTakeEscalations: PulseEscalationEligibility | null): boolean {
  if (PULSE_NO_LIVE_WORK_PERSONAS.includes(persona)) return false;
  if (persona === PulsePersona.TEAM_LEAD) return true;
  return canTakeEscalations === "all";
}

/**
 * The Contact Center's own rule (`ContactCenterV3Service` conversation list):
 * a member limited to some locations sees those locations' conversations and
 * the ones with no location yet. With no conversation reach, they see none.
 */
export function pulseConversationInReach(reach: PulseLocationReach, locationId: number | null): boolean {
  if (reach === "all") return true;
  if (reach.length === 0) return false;
  return locationId === null || reach.includes(locationId);
}

/** Still ringing someone: theirs to answer while it rings (rider 5). `ringingUntil` is ISO, or null when nobody is being offered it. */
export function pulseIsRinging(ringingUntil: string | null, now: Date): boolean {
  return ringingUntil !== null && new Date(ringingUntil).getTime() > now.getTime();
}
